import React from 'react';

import cs from 'classnames';

export interface FormItemProps {
  label: string | JSX.Element;
  helpText?: string | JSX.Element;
  id: string;
  labelClass?: string;
  children: JSX.Element | Array<JSX.Element>;
}

export function FormItem({
  id,
  label,
  labelClass,
  helpText,
  children,
}: FormItemProps) {
  return (
    <div className="d-flex form-group row align-items-center">
      <label
        htmlFor={id}
        className={cs('col-form-label', labelClass, {
          'col-xl-3 col-lg-4 col-md-5 col-sm-6 col-10': labelClass == null,
        })}
      >
        {label}
        {helpText ? (
          <div>
            <span className="text-secondary small">{helpText}</span>
          </div>
        ) : null}
      </label>
      {children}
    </div>
  );
}
